import styled from "styled-components";

const ConsentBannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export default ConsentBannerContent;
